// @flow
export { default } from './InlineError';
